<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
    <div class="rs-pb-circle rs-pb-c3"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">{{ currentMenuItem?.DisplayName || 'Page' }}</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>{{ currentMenuItem?.DisplayName || 'Page' }}</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page" style="font-family:'SolaimanLipi_bold','Ubuntu',sans-serif;">

  <!-- Loading skeleton -->
  <ng-container *ngIf="fetchinData">
    <div class="container">
      <div class="rs-inner-skeleton"></div>
    </div>
  </ng-container>

  <!-- Layout 1 + FileType 1 -->
  <ng-container *ngIf="!fetchinData && check_content_data != null">
    <div class="container" *ngIf="currentContentData[0].LayOut == 1 && currentContentData[0].FileType == 1">
      <div class="rs-inner-card">
        <app-layout-image-list [inputData]="currentContentData[0]"></app-layout-image-list>
      </div>
    </div>
    <!-- Layout 2 + FileType 1 -->
    <div class="container" *ngIf="currentContentData[0].LayOut == 2 && currentContentData[0].FileType == 1">
      <div class="rs-inner-card">
        <app-layout-image-single [inputData]="currentContentData[0]"></app-layout-image-single>
      </div>
    </div>
    <!-- Layout 3 + FileType 1 -->
    <div class="container" *ngIf="currentContentData[0].LayOut == 3 && currentContentData[0].FileType == 1">
      <div class="rs-inner-card">
        <app-layout-image-multiple [inputData]="currentContentData[0]"></app-layout-image-multiple>
      </div>
    </div>
    <!-- Layout 1 + FileType 3 -->
    <div class="container" *ngIf="currentContentData[0].LayOut == 1 && currentContentData[0].FileType == 3">
      <div class="rs-inner-card">
        <app-layout-document-list [inputData]="currentContentData"></app-layout-document-list>
      </div>
    </div>
    <!-- Layout 2 + FileType 3 -->
    <div class="container" *ngIf="currentContentData[0].LayOut == 2 && currentContentData[0].FileType == 3">
      <div class="rs-inner-card">
        <app-layout-document-single [inputData]="currentContentData[0]"></app-layout-document-single>
      </div>
    </div>
    <!-- FileType 0 -->
    <div class="container" *ngIf="currentContentData[0].LayOut == 2 && currentContentData[0].FileType == 0">
      <div class="rs-inner-card">
        <div class="rs-empty-state">
          <i class="ri-file-unknow-line"></i>
          <h4>No content available yet</h4>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- No data -->
  <ng-container *ngIf="!fetchinData && check_content_data == null">
    <div class="container">
      <div class="rs-inner-card">
        <div class="rs-empty-state">
          <i class="ri-inbox-line"></i>
          <h4>No data found for "{{ currentMenuItem?.DisplayName }}"</h4>
        </div>
      </div>
    </div>
  </ng-container>

</div>
